module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-09.294fd3d9.png";